<template>
  <div>
    <top-header :type="6" placeholder="未售房源一房一价" fontSize="0.32rem" />
    <div class="list_main">
      <div id="line" class="pad_top"></div>
      <div class="search_con">
        <van-search
          v-model="formData.value"
          placeholder="请输入项目名称"
          shape="round"
          @search="search"
        />
        <van-overlay :show="Boolean(projectList.length)"> </van-overlay>
        <div class="wrapper" v-show="projectList.length">
          <div class="select_con">
            <div
              class="m_flex_box flex_vc flex_jz row"
              v-for="(item, index) in projectList"
              :key="index"
            >
              <p
                class="left line_comp1"
                @click="setVal2(item.tgmc, item.itemId)"
              >
                [{{ item.xzqh | getAreaName() }}] {{ item.tgmc }}({{
                  item.xmmc
                }})
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="cover_opc" @touchmove.prevent v-show="showCover"></div>
      <div class="tab_con m_flex_box flex_jz fixed">
        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showbuildName === true ? 'active' : ''"
            @click="setTab('showbuildName')"
          >
            <span class="line_comp1">{{
              tabText.showbuildName ? tabText.showbuildName : "楼号"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showbuildName">
              <p
                :class="formData.buildId === item.buildId ? 'active' : ''"
                @click="
                  setVal(
                    'buildId',
                    item.buildId,
                    item.buildName,
                    'showbuildName'
                  )
                "
                v-for="(item, index) in buildList"
                :key="index"
              >
                {{ item.buildName }}({{ item.certificateNo }})
              </p>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showunitNo === true ? 'active' : ''"
            @click="setTab('showunitNo')"
          >
            <span class="line_comp1">{{
              tabText.showunitNo ? tabText.showunitNo : "单元号"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showunitNo">
              <p
                :class="formData.unitNo === item.unitNo ? 'active' : ''"
                @click="
                  setVal('unitNo', item.unitNo, item.unitNo, 'showunitNo')
                "
                v-for="(item, index1) in unitNoList"
                :key="index1"
              >
                {{ item.unitNo }}
              </p>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showhouseNo === true ? 'active' : ''"
            @click="setTab('showhouseNo')"
          >
            <span class="line_comp1">{{
              tabText.showhouseNo ? tabText.showhouseNo : "房号"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showhouseNo">
              <p
                :class="formData.houseId === item.houseId ? 'active' : ''"
                @click="
                  setVal('houseId', item.houseId, item.houseNo, 'showhouseNo')
                "
                v-for="(item, index) in houseNoList"
                :key="index"
              >
                {{ item.houseNo }}
              </p>
            </div>
          </transition>
        </div>

        <div class="inner_con">
          <p
            class="text m_flex_box flex_vc flex_hc"
            :class="tab.showhouseAttribute === true ? 'active' : ''"
            @click="setTab('showhouseAttribute')"
          >
            <span class="line_comp1">{{
              tabText.showhouseAttribute ? tabText.showhouseAttribute : "类型"
            }}</span>
            <van-icon name="play" />
          </p>
          <transition name="slide-y" mode="out-in">
            <div class="inner_list inner_form" v-show="tab.showhouseAttribute">
              <p
                :class="formData.houseAttribute === item.value ? 'active' : ''"
                @click="
                  setVal(
                    'houseAttribute',
                    item.value,
                    item.value,
                    'showhouseAttribute'
                  )
                "
                v-for="(item, index) in houseAttributeList"
                :key="index"
              >
                {{ item.value }}
              </p>
            </div>
          </transition>
        </div>
      </div>
      <div class="main_inner">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="no_data" v-if="!list.length">
              <img src="@/assets/img/nodata.png" alt="" />
            </div>
            <div class="price_list">
              <div
                class="inner m_flex_box flex_vc flex_jz"
                v-for="(item, index) in list"
                :key="index"
                @click="toDetail(item.itemId, item.houseId)"
              >
                <div class="left">
                  <img
                    v-lazy="imgPath + 'sImgHouse/' + item.houseMapID + '.jpg'"
                    alt=""
                  />
                  <p>{{ item.hx }}</p>
                </div>
                <div class="right">
                  <div class="m_flex_box flex_vc flex_jz top">
                    <h5 class="line_comp1">{{ item.tgmc }}</h5>
                    <span>{{ item.houseState }}</span>
                  </div>
                  <img
                    :src="'data:image/png;base64,' + item.base64String"
                    class="info"
                    alt=""
                  />
                  <div class="m_flex_box flex_vc icon_con">
                    <span v-if="item.houseState !== 'null'">{{
                      item.houseState
                    }}</span>
                    <span
                      v-if="
                        item.isDecorate !== 'null' && item.isDecorate !== '-'
                      "
                      >{{ item.isDecorate }}</span
                    >
                    <span v-if="item.saleHouseUse !== 'null'">{{
                      item.saleHouseUse
                    }}</span>
                    <span v-if="item.structType !== 'null'">{{
                      item.structType
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
import slideImg from "@/components/slideImg";
export default {
  name: "OneHouseOnePrice",
  data() {
    return {
      tab: {
        showbuildName: false,
        showunitNo: false,
        showhouseNo: false,
        showYongTu: false,
        showhouseAttribute: false,
      },
      tabText: {
        showbuildName: "",
        showunitNo: "",
        showhouseNo: "",
        showYongTu: "",
        showhouseAttribute: "",
      },
      houseAttributeList: [
        { value: "类型" },
        { value: "商品房" },
        { value: "经适房" },
        { value: "定销房" },
        { value: "动迁房" },
      ],
      formData: {
        value: "",
        xzqh: this.main.getHostArea(),
        houseAttribute: "",
        mc: "",
        order: 0,
        itemId: this.$route.query.itemId,
        buildId: "",
        unitNo: "",
        houseId: "",
        type: 2,
      },
      showCover: false,
      listPage: 1,
      isLoading: false,
      loading: false,
      finished: false,
      items: "",
      list: [],
      buildList: [],
      unitNoList: [],
      houseNoList: [],
      jsonArr: [],
      projectList: [],
      timer: null,
    };
  },
  watch: {
    ["formData.value"](n) {
      this.$set(this, "projectList", []);
      const newArr = [];
      this.jsonArr.forEach(function(item) {
        if (item.tgmc.includes(n) || item.xmmc.includes(n)) {
          newArr.push(item);
        }
      });
      this.$set(this, "projectList", newArr);
      if (n === "") {
        this.$set(this, "projectList", []);
      }
    },
  },
  components: {
    topHeader,
    slideImg,
  },
  filters: {
    getAreaName(value) {
      if (value == "320200") {
        return "主城区"; //主城区
      } else if (value == "320302") {
        return "鼓楼区";
      } else if (value == "320311") {
        return "泉山区";
      } else if (value == "320303") {
        return "云龙区";
      } else if (value == "320398") {
        return "开发区";
      } else if (value == "320312") {
        return "铜山区";
      } else if (value == "320399") {
        return "高新区";
      } else if (value == "320397") {
        return "港务区";
      } else if (value == "320305") {
        return "贾汪区";
      } else if (value == "320321") {
        return "丰县";
      } else if (value == "320381") {
        return "新沂市";
      } else if (value == "320324") {
        return "睢宁县";
      } else if (value == "320322") {
        return "沛县";
      } else if (value == "320382") {
        return "邳州市";
      } else {
        return "主城区";
      }
    },
  },
  mounted() {
    this.getProjectName();
    this.getBuild();
  },
  methods: {
    search() {
      this.$set(this, "listPage", 1);
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.$set(this.formData, "itemId", "");
      this.onLoad();
    },

    setProjectName(itemId) {
      this.$set(this.formData, "itemId", itemId);
      setTimeout(() => {
        this.$set(this, "projectList", []);
      }, 10);
      /*      this.$set(this.formData, 'buildId', '');
            this.$set(this.formData, 'unitNo', '');
            this.$set(this.formData, 'houseId', '');
            this.$set(this.formData, 'houseAttribute', '');
            this.$set(this.tab, 'showbuildName', false);
            this.$set(this.tabText, 'showbuildName', '');
            this.$set(this.tab, 'showunitNo', false);
            this.$set(this.tabText, 'showunitNo', '');
            this.$set(this.tab, 'showhouseNo', false);
            this.$set(this.tabText, 'showhouseNo', '');
            this.$set(this.tab, 'showhouseAttribute', false);
            this.$set(this.tabText, 'showhouseAttribute', '');
            this.showCover = false;*/
      this.listPage = 1;
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },
    getProjectName() {
      this.$new.post("/itemInfo/getItemSearch.do").then((res) => {
        this.jsonArr = res.obj;
      });
    },
    toDetail(itemId, houseId) {
      console.log(21212);
      this.$router.push({
        path: "/oneHouseOnePriceDetail",
        query: { itemId, houseId },
      });
    },
    onRefresh() {
      this.listPage = 1;
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad(1);
    },
    onLoad(type) {
      var that = this;
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50);
        that.$new
              .post(
                "houseApi/getHouseList.do",
                qs.stringify({
                  pageSize: 10,
                  currPageNo: that.listPage,
                  type: 2,
                  order: 0,
                  xzqh: that.main.getHostArea(),
                  buildingId: that.formData.buildId,
                  unitNo: that.formData.unitNo,
                  houseId: that.formData.houseId,
                  houseAttribute: that.formData.houseAttribute,
                  //mc:this.formData.value,
                  itemId: that.formData.itemId,
                })
              )
              .then((res) => {
                if (type) {
                  that.isLoading = false;
                }
                if (res.success) {
                  if (res.obj.length) {
                    that.list = that.list.concat(res.obj);
                    that.loading = false;
                    that.listPage += 1;
                  } else {
                    that.finished = true;
                  }
                } else {
                  that.finished = true;
                }
              });
      }
    },
    getBuild() {
      this.$new
        .post(
          "sale/getBuildByItemId.do",
          qs.stringify({
            itemId: this.formData.itemId,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.$set(this, "buildList", res.obj);
          }
        });
    },

    getunitNo() {
      this.$new
        .post(
          "sale/getUnitNoByBuildId.do",
          qs.stringify({
            buildId: this.formData.buildId,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.$set(this, "unitNoList", res.obj);
            this.items = { unitNo: "单元号" };
            this.unitNoList.splice(0, 0, this.items);
          }
        });
    },

    getHouseList() {
      this.$new
        .post(
          "sale/getHouseNoByUnitNoBuildId.do",
          qs.stringify({
            buildId: this.formData.buildId,
            unitNo: this.formData.unitNo,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.$set(this, "houseNoList", res.obj);
            this.items = { houseId: "", houseNo: "房号" };
            this.houseNoList.splice(0, 0, this.items);
          }
        });
    },

    setTab(type) {
      for (let key in this.tab) {
        if (type === key) {
          this.$set(this.tab, type, !this.tab[type]);
        } else {
          this.$set(this.tab, key, false);
        }
        if (this.tab[type]) {
          this.showCover = true;
        } else {
          this.showCover = false;
        }
      }
    },
    setVal(type, v, t, tab) {
      this.$set(this.formData, type, v);
      if (tab) {
        this.$set(this.tab, tab, false);
        this.$set(this.tabText, tab, t);
        console.log(this.tabText);
        this.showCover = false;
      }

      if (type === "buildId") {
        this.$set(this, "unitNoList", []);
        this.$set(this.tab, "showunitNo", false);
        this.$set(this.formData, "unitNo", "");
        this.$set(this.tabText, "showunitNo", "单元号");
        this.$set(this, "houseNoList", []);
        this.$set(this.tab, "showhouseNo", false);
        this.$set(this.formData, "houseId", "");
        this.$set(this.tabText, "showhouseNo", "房号");
        this.getunitNo(this.formData.buildId);
      }

      if (type === "unitNo") {
        this.$set(this, "houseNoList", []);
        this.$set(this.tab, "showhouseNo", false);
        this.$set(this.formData, "houseId", "");
        this.$set(this.tabText, "showhouseNo", "房号");
        if (this.formData.unitNo === "单元号") {
          this.$set(this.formData, "unitNo", "");
          //this.$toast("请选择单元号!");//提示
        } else {
          this.getHouseList(this.formData.buildId, this.formData.unitNo);
        }
      }
      if (type === "houseId") {
      }

      if (type === "houseAttribute") {
        if (this.formData.houseAttribute === "类型") {
          this.$set(this.formData, "houseAttribute", "");
        }
      }

      this.listPage = 1;
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad();
    },

    setVal2(name, id) {
      //this.projectName = name;
      this.$set(this.formData, "itemId", id);
      this.$set(this, "projectList", []);
      this.showProject = false;
      this.$set(this, "listPage", 1);
      this.finished = false;
      (this.loading = false), this.$set(this, "list", []);

      this.$set(this, "buildList", []);
      this.$set(this.tab, "showbuildName", false);
      this.$set(this.formData, "buildId", "");
      this.$set(this.tabText, "showbuildName", "楼号");

      this.$set(this, "unitNoList", []);
      this.$set(this.tab, "showunitNo", false);
      this.$set(this.formData, "unitNo", "");
      this.$set(this.tabText, "showunitNo", "单元号");
      this.$set(this, "houseNoList", []);
      this.$set(this.tab, "showhouseNo", false);
      this.$set(this.formData, "houseId", "");
      this.$set(this.tabText, "showhouseNo", "房号");

      this.$set(this.tab, "showhouseAttribute", false);
      this.$set(this.formData, "houseAttribute", "");
      this.$set(this.tabText, "showhouseAttribute", "类型");

      this.getBuild();
      this.onLoad();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "OneHouseOnePriceDetail") {
      this.$store.dispatch("saveView", ["OneHouseOnePrice"]).then(() => {
        next();
      });
    } else {
      this.$store.dispatch("saveView", []).then(() => {
        next();
      });
    }
  },
};
</script>
<style lang="less" scoped>
.overLy {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.select_con {
  position: fixed;
  top: 1.9rem;
  background-color: #fff;
  left: 0;
  right: 0;
  height: 60vh;
  overflow: auto;
  padding: 0.23rem;
  font-size: 0.26rem;
  z-index: 5;

  .row {
    height: 0.8rem;
    border-bottom: 1px solid #f5f5f5;

    p {
      font-size: #303030;
    }

    span,
    i {
      color: #a0a0a0;
      font-size: 0.24rem;
    }

    .left {
      width: 82%;
    }
  }
}

/deep/ .van-overlay {
  top: 1.9rem;
}

.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
}

.list_main {
  background-color: #fff;

  h4 {
    font-size: 0.38rem;
    margin: 0rem 0 0.2rem;
    font-weight: 600;
    padding: 0 0.28rem;
  }

  .tab_con {
    padding: 0 0.16rem;
    font-size: 0.28rem;
    position: relative;
    border-bottom: 1px solid #e9e9e9;
    z-index: 2;
    background-color: #fff;

    &.fixed {
      position: fixed;
      top: calc(0.9rem + 44px);
      /* top: 0.9rem;*/
      left: 0;
      right: 0;
      border-top: 1px solid #e9e9e9;
    }

    .inner_con {
      .text {
        padding: 0.2rem 0rem;
        text-align: center;
        width: 1.2rem;

        .van-icon {
          transition: all 0.3s;
          color: #cecece;
          transform: rotate(90deg);
          margin-left: 0.06rem;
          font-size: 0.2rem;
        }

        &.active {
          color: #2f72f5;

          .van-icon {
            transform: rotate(-90deg);
            color: #2f72f5;
          }
        }
      }

      .inner_form {
        background-color: #fff;
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 0.02rem);
        max-height: 7.12rem;
        overflow: auto;
      }

      .inner_list {
        padding: 0 0.5rem;

        p {
          line-height: 0.99rem;
          box-sizing: border-box;
          border-bottom: 1px solid #f4f4f4;
          text-align: center;

          &:last-child {
            border: none;
          }

          &.active {
            color: #2f72f5;
          }
        }
      }
    }
  }
}

.search_con {
  position: fixed;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 0.9rem;
  z-index: 10;
}

.pad_top {
  padding-top: calc(0.82rem + 44px);
  /* padding-top: calc(0.82rem);*/
}

/deep/ .van-search {
  padding-top: 0;
}

.price_list {
  .inner {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f4f4f4;

    &:last-child {
      padding: 0.3rem 0 0;
      border-bottom: 0;
    }

    .left {
      width: 1.94rem;

      img {
        width: 100%;
        height: 1.86rem;
        border: 1px solid #dcdcdc;
        border-bottom: 0;
        display: block;
        box-sizing: border-box;
      }

      p {
        color: #fff;
        background-color: #ff472e;
        font-size: 0.22rem;
        padding: 0.04rem;
        text-align: center;
      }
    }

    .right {
      width: 4.84rem;

      img {
        width: 100%;
      }

      .top {
        position: relative;
        top: -0.04rem;

        h5 {
          font-size: 0.3rem;
          margin-bottom: 0.12rem;
          max-width: 80%;
        }

        span {
          font-size: 0.22rem;
          color: #3072f5;
          border: 1px solid currentColor;
          padding: 0.02rem 0.06rem;
          border-radius: 0.04rem;
        }
      }

      .icon_con {
        margin-top: 0.08rem;

        span {
          padding: 0.04rem 0.06rem;
          color: #6c6d71;
          font-size: 0.22rem;
          background-color: #eef1f6;
          border-radius: 0.04rem;
          margin-right: 0.12rem;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

.van-overlay {
  z-index: 3;
}
</style>
